// :cow: Cosmose CONFIDENTIAL :iso:
export enum FeatureToggle {
  PAYMENT_EVENTS_ENABLED = 'PAYMENT_EVENTS_ENABLED',
  PARCEL_DELIVERY_EVENTS_ENABLED = 'PARCEL_DELIVERY_EVENTS_ENABLED',
  USAGE_OF_LOYALTY_CARD_EVENTS_ENABLED = 'USAGE_OF_LOYALTY_CARD_EVENTS_ENABLED',
  OTHER_EVENTS_ENABLED = 'OTHER_EVENTS_ENABLED',
  FLOORS_VIEW_ENABLED = 'FLOORS_VIEW_ENABLED',
  LOCATION_PREFERENCES_ENABLED = 'LOCATION_PREFERENCES_ENABLED',
  BRANDS_GROUPING_ENABLED = 'BRANDS_GROUPING_ENABLED',
  LOCATIONS_GROUPING_ENABLED = 'LOCATIONS_GROUPING_ENABLED',
  LOCATIONS_AND_FLOORS_GROUPING_ENABLED = 'LOCATIONS_AND_FLOORS_GROUPING_ENABLED',
  BRANDS_FILTERING_ENABLED = 'BRANDS_FILTERING_ENABLED',
  DYNAMIC_GROUPS_ENABLED = 'DYNAMIC_GROUPS_ENABLED',
  UNIQUE_VISITS_ENABLED = 'UNIQUE_VISITS_ENABLED',
  STORE_SEGMENT_SELECTION_ENABLED = 'STORE_SEGMENT_SELECTION_ENABLED',
  CATEGORIES_FILTERING_DISABLED = 'CATEGORIES_FILTERING_DISABLED',
  STORES_FILTERING_BY_ADMINISTRATIVE_LEVEL1_ENABLED = 'STORES_FILTERING_BY_ADMINISTRATIVE_LEVEL1_ENABLED',
  STORE_VISIT_MATRIX_ENABLED = 'STORE_VISIT_MATRIX_ENABLED',
  STORE_DEMOGRAPHICS_ENABLED = 'STORE_DEMOGRAPHICS_ENABLED',
  VISIT_MATRIX_ENABLED = 'VISIT_MATRIX_ENABLED',
  DEMOGRAPHICS_ENABLED = 'DEMOGRAPHICS_ENABLED',
  VISITORS_PREFERENCES_CHART_ENABLED = 'VISITORS_PREFERENCES_CHART_ENABLED',
  PAYING_CUSTOMERS_CHART_ENABLED = 'PAYING_CUSTOMERS_CHART_ENABLED',
}
